import { render, staticRenderFns } from "./CentralLoader.vue?vue&type=template&id=cfec90f0&scoped=true&"
import script from "./CentralLoader.vue?vue&type=script&lang=js&"
export * from "./CentralLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfec90f0",
  null
  
)

export default component.exports